import { LuGroup } from "react-icons/lu";
import { useState } from "react"
import { ModalImageReorder } from "./ModalImageReorder";
import { ImageType } from "../../interfaces/intakes.reports";

interface Props {
    images: ImageType[]
    pid: string
    reportId: string
}

export const GalleryReorder = ({ pid, reportId, images }: Props) => {

    const [openModal, setOpenModal] = useState(false)

    return (
        <>
            {
                openModal &&
                <ModalImageReorder
                    closeModal={() => setOpenModal(false)}
                    palletId={pid}
                    reportId={reportId}
                    images={images}
                />

            }

            <button
                className="tw-flex tw-flex-row-reverse tw-w-full"
                onClick={() => setOpenModal(true)} >
                <LuGroup size={20} />
            </button>

        </>
    )
}
